export const appId = "Rr3sFRefjUpPW8MSITLDSmqDLKCrp8qmJaVcbcda";
export const parseURL = "http://68.183.153.133:1087/parse/";
